import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Welcome from "@/components/site/Welcome";
import Narrative from "@/components/site/Narrative";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Footer from "@/components/site/Footer";
import useReveal from "@/hooks/useReveal";

const Home = () => {
  useReveal();
  return (
    <main data-testid="home-page" className="bg-cm-cream text-cm-ink">
      <Header />
      <Hero />
      <Welcome />
      <Narrative />
      <Manifesto />
      <Services />
      <About />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
